import { createSlice } from '@reduxjs/toolkit';

let host = window.location.hostname;
let version = 'US';
if (host === 'localhost') {
  version = 'US';
} else {
  version = host.includes('-in') ? 'IN' : 'US';
}

const initialState = {
  selectedVersion: version,
};

const versionSlice = createSlice({
  name: 'version',
  initialState,
  reducers: {
    changeVersion(state, action) {
      debugger;
      state.selectedVersion = action.payload;
    },
  },
});

export const { changeVersion } = versionSlice.actions;
export default versionSlice.reducer;
